import { DateAdapter } from '@angular/material/core';

import { ProvidersService } from './../../../services/providers.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../../services/general.service';
import { UsersService } from '../../../services/users.service';
import * as decode from 'jwt-decode';
import { Router } from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { TranslateService } from 'ng2-translate';




@Component({
  selector: 'app-complete-data-general',
  templateUrl: './complete-data-general.component.html',
  styleUrls: ['./complete-data-general.component.scss']
})
export class CompleteDataGeneralComponent implements OnInit {
  
  userId: any;
  userToken: any;
  userpass: any = {};
  userInfo: any = {};
  noProvider: any;
  load = true;
  loadBtn = false;
  tokenPayload;
  temp;

  language= 'es';
  errosTostr:any;
  isExtern;
  politicas=false;

  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private usersService: UsersService, private router: Router, private provService: ProvidersService,
    public dialogRef: MatDialogRef<CompleteDataGeneralComponent>, private translate: TranslateService, private adapter: DateAdapter<any>) {
    this.userInfo ;    
    
      this.language = localStorage.getItem('language');
      this.temp  = localStorage.getItem('tempRegister');
      if (!this.temp) {
        console.error('El token no está definido o no es válido');
        this.router.navigate(['/login']); // Redirigir al login si no hay token
        return;
      }
      this.tokenPayload = decode(this.temp);
      console.log(this.tokenPayload);
      this.isExtern = this.tokenPayload.EsUsuarioExterno;
        
      this.userId = this.tokenPayload.Id;
      this.noProvider = this.tokenPayload.IdProveedor;      
      

      translate.onLangChange.subscribe(lang => {
        if(lang.lang == 'en'){
          this.adapter.setLocale('en-GB');
          this.language = 'en';
        }
  
        if(lang.lang == 'es'){
          // this.adapter.setLocale('es-MX');
          // this.language = 'es';
          this.adapter.setLocale('en-GB');
          this.language = 'en';
        }
      });
  }

  ngOnInit() {
    this.callInfo();
    this.translate.getTranslation(this.language).subscribe((res:any)=>{
      this.errosTostr = res.ERRORTOASTR;
    });

  }

  save(){
    this.toastr.clear();
    this.loadBtn = true;
    let validedForm = this.validateInfo();

    if(validedForm.success){
      

      let params ={ 
                    Usuario:{
                              "Id":this.userId,
                              "Nombre": this.userInfo.Nombre,
                              "Apellidos": this.userInfo.Apellidos,
                              "AnteriorPassword": this.userInfo.oldPw ,
                              "NuevoPassword": this.userInfo.newPw,
                              "Email": this.userInfo.Email
                    },
                    ProveedorDireccion:{
                                        "Proveedor": {
                                                      "IdProveedor": this.noProvider,
                                                      "Nombre": this.userInfo.razonSocial ,
                                                      "RFC" : this.userInfo.rfc,
                                                      "Email":  this.userInfo.EmailProveedor
                                        },
                                        "Direccion": {
                                                "Direccion1": null,
                                                "Direccion2": null ,
                                                "Ciudad": null ,
                                                "Estado": null  ,
                                                "Pais": null ,
                                                "CP": this.userInfo.cp
                                        }                          
                  }
                };
      if(!this.isExtern){
        this.usersService.completeInfo(params, this.userId, this.temp ).then((res:any)=>{      
          if(res.EsValido){
            localStorage.setItem('G13xTfsdf234TVsd23513ffdgFdf2352', 'Bearer '+this.temp);
              
            
            if(this.tokenPayload.IdPerfil == 3){
              this.provService.getMessages(this.tokenPayload.IdProveedor, this.tokenPayload.Id, localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352')).then((dataMsg) => {
                if(dataMsg['EsValido']){
                  localStorage.setItem('firstSession', 'no');
                  this.dialogRef.close();
                  this.toastr.success(this.errosTostr.SUCCESSDATAPROVIDER, '', {disableTimeOut: false, closeButton: true});
                  this.loadBtn = false;

                  this.router.navigate(['/', 'inicio']);
                }
              }, (err) => {
                this.toastr.error( 'No se pudo actualizar su información, intentalo más tarde', '', {disableTimeOut: true, closeButton: true});
                this.loadBtn = false;
                console.log(err);
              });
            }
            
          }else{
            if(res.Codigo == '01'){                                 
              this.toastr.error( this.errosTostr.CURRENTPW ,   '', {disableTimeOut: true, closeButton: true});
              this.loadBtn = false;                  
              
              return false;
            } else{                
                this.toastr.error( this.errosTostr.NEWPW ,   '', {disableTimeOut: true, closeButton: true});
                this.loadBtn = false;                  
            }

            this.loadBtn = false;
            
          }
          
        });
      }else{
        this.gralService.validateRfc({rfc:this.userInfo.rfc  }, 'kjsdg876wetkjsdg124putomanu23786' ).then(res=>{
          if(res == 1){
            this.usersService.completeInfo(params, this.userId, this.temp ).then((res:any)=>{      
              if(res.EsValido){
                localStorage.setItem('G13xTfsdf234TVsd23513ffdgFdf2352', 'Bearer '+this.temp);
                  
                
                if(this.tokenPayload.IdPerfil == 3){
                  this.provService.getMessages(this.tokenPayload.IdProveedor, this.tokenPayload.Id, localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352')).then((dataMsg) => {
                    if(dataMsg){
                      localStorage.setItem('firstSession', 'no');
                      this.dialogRef.close();
                      this.toastr.success(this.errosTostr.SUCCESSDATAPROVIDER, '', {disableTimeOut: false, closeButton: true});
                      this.loadBtn = false;
  
                      this.router.navigate(['/', 'inicio']);
                    }
                  }, (err) => {
                    this.toastr.error( 'No se pudo actualizar su información, intentalo más tarde', '', {disableTimeOut: true, closeButton: true});
                    this.loadBtn = false;
                    console.log(err);
                  });
                }
                
              }else{
                if(res.Codigo == '01'){                                 
                  this.toastr.error( this.errosTostr.CURRENTPW ,   '', {disableTimeOut: true, closeButton: true});
                  this.loadBtn = false;                  
                  
                  return false;
                } else{                
                    this.toastr.error( this.errosTostr.NEWPW ,   '', {disableTimeOut: true, closeButton: true});
                    this.loadBtn = false;                  
                }
  
                this.loadBtn = false;
                
              }
              
            });
          }else{
            this.loadBtn = false;
            this.toastr.error(this.errosTostr.RFCERROR, '');
            
          }
        });
      }
      

      
      
    }else{
      this.loadBtn = false;
      this.toastr.error(validedForm.msg, '');
    }
    
  }

  validacionRFC ;
  validateInfo(){
    if(!this.isExtern){ 
      if(this.userInfo.razonSocial == '' || this.userInfo.razonSocial == undefined ){ return {success: false, msg: "Debes ingresar el campo razón social"  }}
      if(this.userInfo.rfc == ''    || this.userInfo.rfc == undefined ){ return {success: false, msg: "Debes ingresar el campo RFC"  }}
      if(this.userInfo.EmailProveedor == ''    || this.userInfo.EmailProveedor == undefined ){ return {success: false, msg: "Debes ingresar el campo correo proveedor" } }

      if(!this.validateEmail(this.userInfo.EmailProveedor) ){
        return {success: false, msg: "Debes ingresar un correo válido" }
      }
      
      setTimeout(()=>{
        if(!this.validacionRFC){ return {success: false, msg: "El RFC es incorrecto" }; }
      }, 500);
    // if(this.userInfo.pais == ''   || this.userInfo.pais == undefined ){ return {success: false, msg: "Debes ingresar el campo país"  }}
      if(this.userInfo.cp == ''     || this.userInfo.cp == undefined ){ return {success: false, msg: this.errosTostr.POSTALCODE  }}
    }
    // if(this.userInfo.estado == '' || this.userInfo.estado == undefined ){ return {success: false, msg: "Debes ingresar el campo estado"  }}
    // if(this.userInfo.ciudad == '' || this.userInfo.ciudad == undefined ){ return {success: false, msg: "Debes ingresar el campo ciudad"  }}
    // if(this.userInfo.colonia == ''|| this.userInfo.colonia == undefined ){ return {success: false, msg: "Debes ingresar el campo colonia"  }}
    // if(this.userInfo.calle == ''  || this.userInfo.calle == undefined ){ return {success: false, msg: "Debes ingresar el campo calle" }}
    if(this.userInfo.Nombre == ''  || this.userInfo.Nombre == undefined ){ return {success: false, msg: this.errosTostr.NAME  }}
    // if(this.userInfo.Apellidos == ''  || this.userInfo.Apellidos == undefined ){ return {success: false, msg: "Debes ingresar el campo apellidos" }}
    if(this.userInfo.Email == ''  || this.userInfo.Email == undefined ){ return {success: false, msg: this.errosTostr.EMAIL  }}
    if(!this.validateEmail(this.userInfo.Email) ){
      return {success: false, msg: this.errosTostr.MAILVALID }
    }
    if(this.userInfo.oldPw == ''  || this.userInfo.oldPw == undefined ){ return {success: false, msg: this.errosTostr.OLDPW  }}
    if(this.userInfo.newPw == ''  || this.userInfo.newPw == undefined ){ return {success: false, msg: this.errosTostr.NEWPWREQ }}
    if(this.userInfo.confirmPw == ''  || this.userInfo.confirmPw == undefined ){ return {success: false, msg: this.errosTostr.CONFIRMPW  }}

    if(this.userInfo.newPw != this.userInfo.confirmPw ){ return {success: false, msg: this.errosTostr.MATCHPW  }}

    if(!this.politicas){return {success: false, msg: this.errosTostr.POLICY } }
    return {success: true, msg: "Todo es válido"};
  }
  

  validateEmail(email){
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  callInfo(){
    this.provService.getInfoProviderFirstSession(this.userId, this.temp).then((res:any) =>{
      console.log(res.Entidad);
      if(res.Entidad){
        const info = res.Entidad;
          this.userInfo.razonSocial     = info.ProveedorDireccion.Proveedor.Nombre;
          this.userInfo.rfc             = info.ProveedorDireccion.Proveedor.RFC;
          this.userInfo.EmailProveedor  = info.ProveedorDireccion.Proveedor.Email;
          this.userInfo.cp              = info.ProveedorDireccion.Direccion.CP
          this.userInfo.Nombre          = info.Usuario.Nombre;
          this.userInfo.Apellidos       = info.Usuario.Apellidos;
          this.userInfo.Email           = info.Usuario.Email;
      }
    });
  }

  toggleEditable(e){
    console.log('evento----',this.politicas);
  }
}
